import { useQuery } from 'react-query'

import { getGraduations } from '../../apis/public.api'

export interface IGrade {
  id: string;
  createdAt: Date;
  name: string;
  status: string;
}

function useGradeList() {
  return useQuery(['grade-list'], async () => {
    const data: IGrade[] = await getGraduations();

    const gradesData = {
      graduations: data,
      total: data.length,
    }

    return gradesData
  },
  )
}

export { useGradeList }
